import { Image } from "./image";
import { NavLink, Router } from "react-router-dom";

export const Gallery = (props) => {

  console.log(props.data);
  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Portafolio</h2>
          <p>
            Una pequeña muestras de los proyectos realizados apartir desde wordpress, hasta WebApps
          </p>
        </div>
        <div className='row'>
          <div className='portfolio-items'>
            {props.data
              ? props.data.map((d, i) => (
                
                <div key={`${d.title}-${i}`} className='col-sm-6 col-md-4 col-lg-4'>
                    <Image title={d.title} largeImage={d.UrlImg} smallImage={d.smallImage} to={`${d.UrlImg}`}/>
                </div>
                
              ))
              : 'Loading...'}
          </div>
        </div>
      </div>
    </div>
  )
}
